// const SvgIcon = ({ size='24', color='#fff' }) => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width={size}
//     height={size}
//     fill="none"
//     stroke={color}
//     strokeLinecap="round"
//     strokeLinejoin="round"
//     strokeWidth="2"
//     viewBox="0 0 24 24"
//   >
//     <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
//   </svg>
// );
// 
// export default SvgIcon;

const SvgIcon = ({ size='24', color='#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="svg2050"
    width={size}
    height={size}
    fill="none"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <path
      id="path2048"
      fill={color}
      fillOpacity="1"
      strokeWidth="1"
      d="M21.6 0H2.4A2.4 2.4 0 0 0 0 2.4V24l4.8-4.8h16.8a2.4 2.4 0 0 0 2.4-2.4V2.4A2.4 2.4 0 0 0 21.6 0"
    ></path>
  </svg>
);

export default SvgIcon;
